import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanIsNoAddressNeeded } from "./is-no-address-needed";
import { QuestionPlanIsChangeOnlyOption } from "./is-only-change-option";
import { QuestionPlanIsRequest } from "./is-request";
import { QuestionPlanIsSecret } from "./is-secret";
import { QuestionPlanIsUncancelable } from "./is-uncancelable";
import { QuestionPlanIsUnchangeable } from "./is-unchangeable";
import { QuestionPlanMealConditions } from "./meal-conditions";
import { QuestionPlanOnlyUseCreditPayment } from "./only-use-credit-payment";

import type { PlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	planAttributes: PlanCategoriesAndManagerStore["planAttributes"];
};

export const QuestionPlanAttributes = ({ planAttributes }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="予約方法に関する制限" categoryStore={planAttributes}>
				<QuestionPlanOnlyUseCreditPayment />
				<QuestionPlanIsRequest />
				<QuestionPlanIsUnchangeable />
				<QuestionPlanIsUncancelable />
				<QuestionPlanIsChangeOnlyOption />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="予約情報に関する設定" categoryStore={planAttributes}>
				<QuestionPlanIsNoAddressNeeded />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="食事に関する設定" categoryStore={planAttributes}>
				<QuestionPlanMealConditions />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="シークレットプランの設定" categoryStore={planAttributes}>
				<QuestionPlanIsSecret />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionPlanAttributes.displayName = "QuestionPlanAttributes";
